// components/clients/ClientMetricGrid.jsx
import React from 'react';

const ClientMetric = ({ label, value }) => (
  <div className="mobile-client-metric">
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

// Grille des métriques de la fiche cliente (paires, commandes, valeur, dernier achat).
export const ClientMetricGrid = ({ metrics }) => (
  <section className="mobile-client-detail-summary">
    {metrics.map((metric) => (
      <ClientMetric key={metric.label} label={metric.label} value={metric.value} />
    ))}
  </section>
);
